const reviewDurationToCommentsResp = {
    error: null,
    overall: {
        value: 0.18999958847608253,
        significance: "negligible",
        explanation:
            "They are negligibly correlated, potentially meaning that the size of your pull requests is not correlated with the   \n        amount of time it takes to complete it.",
        description:
            "For the entirety of time we have data on your Pull Requests, it seems that there is n negligible correlation between the PR review duration and of the number of comments on that pull request review.that the amount of comments on your pull requests is not correlated with the amount of time it takes to be reviewed.\n        \n        However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it. And in that case you may not want to stress over the amount of comments reviews have.",
        error: null,
    },
    smaller_frame: {
        value: 0.22907575681150452,
        significance: "weak",
        explanation:
            "They are weakly positively correlated, potentially meaning that pull requests of bigger size may may have a small \n            effect on the amount of time it takes to complete a Pull Request.",
        description:
            "For last 30 merged and reviewed PRs, it seems that that pull requests with more comments may sometimes take longer to be reviewed.\n        \n        However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it. And in that case you might want to examine if there are some small improvements to be done be finding the common denominators accross the more slow reviews (eg legacy project, complex part of the code).",
        frame_name: "Last 30 merged and reviewed PRs",
        error: null,
    },
    graph: {
        data: [
            {
                datetime: "2023-06-15T10:23:15.000Z",
                under_review_duration_sec: 7462.0,
                comments: 1,
                correlation: -0.0992722669,
                trend_line: 2.0806339686,
            },
            {
                datetime: "2023-06-19T11:11:06.000Z",
                under_review_duration_sec: 334759.0,
                comments: 9,
                correlation: 0.244764942,
                trend_line: 5.5954063406,
            },
            {
                datetime: "2023-06-19T12:39:46.000Z",
                under_review_duration_sec: 15958.0,
                comments: 6,
                correlation: 0.2366969055,
                trend_line: 1.8549849,
            },
            {
                datetime: "2023-06-19T12:50:17.000Z",
                under_review_duration_sec: 10826.0,
                comments: 8,
                correlation: 0.2189906976,
                trend_line: 1.9884026853,
            },
            {
                datetime: "2023-06-20T10:14:48.000Z",
                under_review_duration_sec: 7231.0,
                comments: 1,
                correlation: 0.2211835916,
                trend_line: 2.0871072415,
            },
            {
                datetime: "2023-06-20T10:15:03.000Z",
                under_review_duration_sec: 7158.0,
                comments: 1,
                correlation: 0.2232496346,
                trend_line: 2.0891566594,
            },
            {
                datetime: "2023-06-20T10:15:14.000Z",
                under_review_duration_sec: 7158.0,
                comments: 1,
                correlation: 0.2251892014,
                trend_line: 2.0891566594,
            },
            {
                datetime: "2023-06-20T10:15:22.000Z",
                under_review_duration_sec: 7161.0,
                comments: 1,
                correlation: 0.2270131264,
                trend_line: 2.0890724012,
            },
            {
                datetime: "2023-06-20T10:15:31.000Z",
                under_review_duration_sec: 7165.0,
                comments: 1,
                correlation: 0.2287312828,
                trend_line: 2.0889600617,
            },
            {
                datetime: "2023-06-20T10:15:45.000Z",
                under_review_duration_sec: 7164.0,
                comments: 1,
                correlation: 0.2303532768,
                trend_line: 2.0889881461,
            },
            {
                datetime: "2023-06-20T10:41:48.000Z",
                under_review_duration_sec: 7763.0,
                comments: 1,
                correlation: 0.2318049349,
                trend_line: 2.0722261524,
            },
            {
                datetime: "2023-06-20T10:55:12.000Z",
                under_review_duration_sec: 9.0,
                comments: 1,
                correlation: 0.2341663939,
                trend_line: 2.2986466445,
            },
            {
                datetime: "2023-06-20T15:18:08.000Z",
                under_review_duration_sec: 784.0,
                comments: 7,
                correlation: 0.2173956501,
                trend_line: 2.2750908235,
            },
            {
                datetime: "2023-06-21T11:28:30.000Z",
                under_review_duration_sec: 10347.0,
                comments: 1,
                correlation: 0.2183394952,
                trend_line: 2.0013033425,
            },
            {
                datetime: "2023-06-21T11:29:12.000Z",
                under_review_duration_sec: 61577.0,
                comments: 1,
                correlation: 0.2100911806,
                trend_line: 1.0365632931,
            },
            {
                datetime: "2023-06-21T14:08:21.000Z",
                under_review_duration_sec: 1370.0,
                comments: 1,
                correlation: 0.2122858916,
                trend_line: 2.2574168353,
            },
            {
                datetime: "2023-06-22T07:30:21.000Z",
                under_review_duration_sec: 7103.0,
                comments: 1,
                correlation: 0.2136590106,
                trend_line: 2.0907019318,
            },
            {
                datetime: "2023-06-23T07:18:16.000Z",
                under_review_duration_sec: 148.0,
                comments: 1,
                correlation: 0.2158073517,
                trend_line: 2.2944065636,
            },
            {
                datetime: "2023-06-23T13:12:38.000Z",
                under_review_duration_sec: 10586.0,
                comments: 1,
                correlation: 0.2166003359,
                trend_line: 1.9948568716,
            },
            {
                datetime: "2023-06-23T13:12:55.000Z",
                under_review_duration_sec: 10754.0,
                comments: 1,
                correlation: 0.2173377272,
                trend_line: 1.9903369157,
            },
            {
                datetime: "2023-06-23T13:14:17.000Z",
                under_review_duration_sec: 98498.0,
                comments: 5,
                correlation: 0.2370937069,
                trend_line: 0.8166309853,
            },
            {
                datetime: "2023-06-26T04:20:44.000Z",
                under_review_duration_sec: 56.0,
                comments: 1,
                correlation: 0.437333366,
                trend_line: 2.2972122026,
            },
            {
                datetime: "2023-06-28T13:39:19.000Z",
                under_review_duration_sec: 321.0,
                comments: 1,
                correlation: 0.4502841823,
                trend_line: 2.2891386435,
            },
            {
                datetime: "2023-06-28T15:34:13.000Z",
                under_review_duration_sec: 2162.0,
                comments: 8,
                correlation: 0.3996213452,
                trend_line: 2.2337172615,
            },
            {
                datetime: "2023-06-28T15:34:27.000Z",
                under_review_duration_sec: 139.0,
                comments: 1,
                correlation: 0.3998891497,
                trend_line: 2.2946808995,
            },
            {
                datetime: "2023-06-30T08:50:34.000Z",
                under_review_duration_sec: 568.0,
                comments: 1,
                correlation: 0.4010102576,
                trend_line: 2.2816352646,
            },
            {
                datetime: "2023-07-03T07:04:56.000Z",
                under_review_duration_sec: 1057.0,
                comments: 1,
                correlation: 0.4019979582,
                trend_line: 2.2668423459,
            },
            {
                datetime: "2023-07-03T09:26:23.000Z",
                under_review_duration_sec: 223329.0,
                comments: 1,
                correlation: 0.3258699199,
                trend_line: 2.3565386075,
            },
            {
                datetime: "2023-07-03T09:59:17.000Z",
                under_review_duration_sec: 3208.0,
                comments: 2,
                correlation: 0.323306068,
                trend_line: 2.2027465618,
            },
            {
                datetime: "2023-07-03T15:25:42.000Z",
                under_review_duration_sec: 4552.0,
                comments: 1,
                correlation: 0.3785678642,
                trend_line: 2.1635014026,
            },
            {
                datetime: "2023-07-03T15:26:22.000Z",
                under_review_duration_sec: 2920.0,
                comments: 1,
                correlation: 0.3782429756,
                trend_line: 2.2112365057,
            },
            {
                datetime: "2023-07-05T15:04:38.000Z",
                under_review_duration_sec: 9962.0,
                comments: 1,
                correlation: 0.3770242828,
                trend_line: 2.0117281002,
            },
            {
                datetime: "2023-07-11T13:15:02.000Z",
                under_review_duration_sec: 15055.0,
                comments: 1,
                correlation: 0.3750930026,
                trend_line: 1.8778266612,
            },
            {
                datetime: "2023-07-12T04:19:39.000Z",
                under_review_duration_sec: 978.0,
                comments: 3,
                correlation: 0.3687696195,
                trend_line: 2.269226632,
            },
            {
                datetime: "2023-07-13T07:05:12.000Z",
                under_review_duration_sec: 95602.0,
                comments: 1,
                correlation: 0.3477791389,
                trend_line: 0.8207905603,
            },
            {
                datetime: "2023-07-13T07:06:56.000Z",
                under_review_duration_sec: 76138.0,
                comments: 1,
                correlation: 0.3340911233,
                trend_line: 0.9055884019,
            },
            {
                datetime: "2023-07-13T07:26:29.000Z",
                under_review_duration_sec: 590.0,
                comments: 1,
                correlation: 0.3340302793,
                trend_line: 2.2809679665,
            },
            {
                datetime: "2023-07-19T08:07:18.000Z",
                under_review_duration_sec: 64381.0,
                comments: 1,
                correlation: 0.3228389474,
                trend_line: 1.0066882919,
            },
            {
                datetime: "2023-07-19T08:07:27.000Z",
                under_review_duration_sec: 64376.0,
                comments: 1,
                correlation: 0.3119262712,
                trend_line: 1.0067395632,
            },
            {
                datetime: "2023-07-19T08:07:34.000Z",
                under_review_duration_sec: 64279.0,
                comments: 1,
                correlation: 0.3012263114,
                trend_line: 1.0077356355,
            },
            {
                datetime: "2023-07-19T08:07:42.000Z",
                under_review_duration_sec: 65252.0,
                comments: 1,
                correlation: 0.2904871016,
                trend_line: 0.9978654963,
            },
            {
                datetime: "2023-07-24T09:39:24.000Z",
                under_review_duration_sec: 62618.0,
                comments: 1,
                correlation: 0.2804505552,
                trend_line: 1.025209147,
            },
            {
                datetime: "2023-07-25T08:31:00.000Z",
                under_review_duration_sec: 10118.0,
                comments: 1,
                correlation: 0.2796454238,
                trend_line: 2.007498051,
            },
            {
                datetime: "2023-07-25T08:33:14.000Z",
                under_review_duration_sec: 1144.0,
                comments: 1,
                correlation: 0.2795288616,
                trend_line: 2.2642190961,
            },
            {
                datetime: "2023-07-25T10:10:50.000Z",
                under_review_duration_sec: 8580.0,
                comments: 1,
                correlation: 0.2790012302,
                trend_line: 2.0495590684,
            },
            {
                datetime: "2023-07-26T06:16:25.000Z",
                under_review_duration_sec: 32.0,
                comments: 4,
                correlation: 0.2796744498,
                trend_line: 2.2979445884,
            },
            {
                datetime: "2023-07-28T11:37:05.000Z",
                under_review_duration_sec: 2870.0,
                comments: 1,
                correlation: 0.279390173,
                trend_line: 2.2127133448,
            },
            {
                datetime: "2023-08-02T07:44:24.000Z",
                under_review_duration_sec: 2348.0,
                comments: 1,
                correlation: 0.2942123098,
                trend_line: 2.2281826529,
            },
            {
                datetime: "2023-08-02T08:54:50.000Z",
                under_review_duration_sec: 36.0,
                comments: 4,
                correlation: 0.302027443,
                trend_line: 2.2978225103,
            },
            {
                datetime: "2023-08-02T13:33:25.000Z",
                under_review_duration_sec: 1649.0,
                comments: 1,
                correlation: 0.3177240765,
                trend_line: 2.2490435575,
            },
            {
                datetime: "2023-08-02T13:40:43.000Z",
                under_review_duration_sec: 473.0,
                comments: 1,
                correlation: 0.3184573036,
                trend_line: 2.2845186927,
            },
            {
                datetime: "2023-08-02T13:45:20.000Z",
                under_review_duration_sec: 186.0,
                comments: 1,
                correlation: -0.0643491365,
                trend_line: 2.2932485642,
            },
            {
                datetime: "2023-08-03T07:44:33.000Z",
                under_review_duration_sec: 57487.0,
                comments: 1,
                correlation: -0.0677511968,
                trend_line: 1.084201228,
            },
            {
                datetime: "2023-08-03T07:53:02.000Z",
                under_review_duration_sec: 248.0,
                comments: 2,
                correlation: -0.0579221224,
                trend_line: 2.2913602652,
            },
            {
                datetime: "2023-08-03T12:32:35.000Z",
                under_review_duration_sec: 3164.0,
                comments: 4,
                correlation: -0.0741406543,
                trend_line: 2.2040418008,
            },
            {
                datetime: "2023-08-03T12:33:19.000Z",
                under_review_duration_sec: 8070.0,
                comments: 1,
                correlation: -0.074332701,
                trend_line: 2.0636822503,
            },
            {
                datetime: "2023-08-08T11:24:28.000Z",
                under_review_duration_sec: 4222.0,
                comments: 1,
                correlation: -0.07370951,
                trend_line: 2.1730804135,
            },
            {
                datetime: "2023-08-09T07:22:54.000Z",
                under_review_duration_sec: 487996.0,
                comments: 10,
                correlation: 0.489669935,
                trend_line: 10.4766823238,
            },
            {
                datetime: "2023-08-09T08:30:30.000Z",
                under_review_duration_sec: 237.0,
                comments: 13,
                correlation: 0.3407597659,
                trend_line: 2.2916951893,
            },
            {
                datetime: "2023-08-09T08:38:33.000Z",
                under_review_duration_sec: 84980.0,
                comments: 1,
                correlation: 0.3311519208,
                trend_line: 0.8546040064,
            },
            {
                datetime: "2023-08-09T08:39:01.000Z",
                under_review_duration_sec: 84811.0,
                comments: 1,
                correlation: 0.3218246267,
                trend_line: 0.8553815404,
            },
            {
                datetime: "2023-08-09T09:46:39.000Z",
                under_review_duration_sec: 3224.0,
                comments: 9,
                correlation: 0.2753692761,
                trend_line: 2.2022757299,
            },
            {
                datetime: "2023-08-09T13:26:22.000Z",
                under_review_duration_sec: 6414.0,
                comments: 1,
                correlation: 0.3045481179,
                trend_line: 2.1101467295,
            },
            {
                datetime: "2023-08-09T13:26:36.000Z",
                under_review_duration_sec: 7794.0,
                comments: 1,
                correlation: 0.3047546969,
                trend_line: 2.0713619691,
            },
            {
                datetime: "2023-08-09T13:27:34.000Z",
                under_review_duration_sec: 12880.0,
                comments: 1,
                correlation: 0.3101327904,
                trend_line: 1.9339530588,
            },
            {
                datetime: "2023-08-09T13:27:47.000Z",
                under_review_duration_sec: 12896.0,
                comments: 1,
                correlation: 0.3092172462,
                trend_line: 1.9335344369,
            },
            {
                datetime: "2023-08-09T15:38:30.000Z",
                under_review_duration_sec: 26.0,
                comments: 4,
                correlation: 0.2984684622,
                trend_line: 2.2981277159,
            },
            {
                datetime: "2023-08-10T15:05:24.000Z",
                under_review_duration_sec: 477.0,
                comments: 7,
                correlation: 0.2697343771,
                trend_line: 2.2843972226,
            },
            {
                datetime: "2023-08-12T12:26:54.000Z",
                under_review_duration_sec: 11065.0,
                comments: 1,
                correlation: 0.2696863756,
                trend_line: 1.9819945557,
            },
            {
                datetime: "2023-09-05T08:40:36.000Z",
                under_review_duration_sec: 210.0,
                comments: 1,
                correlation: 0.270691784,
                trend_line: 2.2925174525,
            },
            {
                datetime: "2023-09-05T09:15:07.000Z",
                under_review_duration_sec: 67.0,
                comments: 1,
                correlation: 0.2602436077,
                trend_line: 2.2968765922,
            },
            {
                datetime: "2023-09-20T09:46:18.000Z",
                under_review_duration_sec: 4926.0,
                comments: 1,
                correlation: 0.2598099844,
                trend_line: 2.1526900314,
            },
            {
                datetime: "2023-09-22T06:49:26.000Z",
                under_review_duration_sec: 3223.0,
                comments: 1,
                correlation: 0.2595534715,
                trend_line: 2.2023051543,
            },
            {
                datetime: "2023-09-22T11:28:04.000Z",
                under_review_duration_sec: 1500.0,
                comments: 1,
                correlation: 0.2945998775,
                trend_line: 2.2535119817,
            },
            {
                datetime: "2023-09-25T08:43:26.000Z",
                under_review_duration_sec: 1969.0,
                comments: 1,
                correlation: 0.2944616917,
                trend_line: 2.239472701,
            },
            {
                datetime: "2023-09-25T08:45:59.000Z",
                under_review_duration_sec: 229812.0,
                comments: 1,
                correlation: 0.2543876743,
                trend_line: 2.5106233305,
            },
            {
                datetime: "2023-09-25T10:45:27.000Z",
                under_review_duration_sec: 9.0,
                comments: 1,
                correlation: 0.2544637287,
                trend_line: 2.2986466445,
            },
            {
                datetime: "2023-09-27T07:42:58.000Z",
                under_review_duration_sec: 18000.0,
                comments: 1,
                correlation: 0.2911357495,
                trend_line: 1.8043229702,
            },
            {
                datetime: "2023-09-27T14:49:15.000Z",
                under_review_duration_sec: 2565.0,
                comments: 1,
                correlation: 0.2937048916,
                trend_line: 2.2217405928,
            },
            {
                datetime: "2023-09-28T07:58:34.000Z",
                under_review_duration_sec: 2596.0,
                comments: 1,
                correlation: 0.293852132,
                trend_line: 2.2208216152,
            },
            {
                datetime: "2023-09-29T07:28:25.000Z",
                under_review_duration_sec: 262913.0,
                comments: 1,
                correlation: 0.2463788381,
                trend_line: 3.378077269,
            },
            {
                datetime: "2023-09-29T07:44:01.000Z",
                under_review_duration_sec: 146.0,
                comments: 2,
                correlation: 0.2439630247,
                trend_line: 2.2944675247,
            },
            {
                datetime: "2023-10-03T13:38:27.000Z",
                under_review_duration_sec: 521.0,
                comments: 1,
                correlation: 0.2450835433,
                trend_line: 2.2830614143,
            },
            {
                datetime: "2023-10-04T06:44:31.000Z",
                under_review_duration_sec: 1021.0,
                comments: 9,
                correlation: 0.2095033005,
                trend_line: 2.2679285898,
            },
        ],
        explanation:
            "This is the graph is showing the correlation between PR review duration and the PR review comments.\n            Any data points above the 0.2 and below the -0.2 lines have a statistically significant correlation.\n            ",
        description:
            "It has been produced by calculating the correlation coefficient on a rolling PR window of 50 Pull Requests, in order to smoothen the curve and depict the general direction of the move while minimizing the noise. This means that we take a window of the 50 first PRs and we calculate the correlation coefficient, then we remove the oldest PR and we add a new one calculating again the correlation, and we keep doing that until we reach the end of the dataset, meaning the most recent PRs.\n            \n            These have been the best settings we have found to be working better for this calculation. However, we will allow you to set this settings in any value you see more fit.\n            \n            Any data points above the 0.2 line have a statistically significant positive correlation, meaning when one of the variable increases the other one does too. Also any data points below -0.2 represent a\n            statistically significant negative correlation, meaning when one variable increases the other one does reduce. The higher or lower from 0 a data point is the more positively or negatively our two variables are correlated indicatign that they potentially affect each other more.\n            ",
        error: null,
    },
};
export default reviewDurationToCommentsResp;
